import { keyframes, style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

const animation = keyframes({
  to: { backgroundPositionX: '0%' }
})

export const shimmer = style({
  background: 'linear-gradient(-45deg, #eee 40%, #fafafa 50%, #eee 60%)',
  backgroundSize: '300%',
  backgroundPositionX: '100%',
  borderRadius: vars.blocks.radius,
  gridColumn: '1 / -1',
  animation: `${animation} 1s infinite linear`
})
